const BACKEND_URL = "https://pb1zhtyev3.execute-api.us-east-1.amazonaws.com/prod"
const MAKE_ERROR_NOTIFICATION_URL = "https://hook.eu2.make.com/x9pgr07ay2kogewql4w8l3y27wavixwe"


export { BACKEND_URL, MAKE_ERROR_NOTIFICATION_URL };